module.exports = __webpack_public_path__ + "static/img/yu.4455c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/yu.png
// module id = rI+8
// module chunks = 0